/*
	Rubin v16 (2026-08-07) – toggle for the desktop "Produktdetails" area.
	Follows the theme pattern of small external assets loaded with defer.
	Keyboard accessible (native <button>), aria-expanded/aria-controls wired
	in the Liquid markup, honours prefers-reduced-motion for the scroll.
*/
(function () {
	'use strict';

	function bind(btn) {
		if (btn.dataset.rubinBound) return;
		btn.dataset.rubinBound = '1';

		var targetId = btn.getAttribute('aria-controls');
		var details = targetId ? document.getElementById(targetId) : null;
		if (!details) return;

		var label = btn.querySelector('.rubin-desc-split-toggle__label');

		btn.addEventListener('click', function () {
			var open = details.classList.toggle('is-open');
			btn.setAttribute('aria-expanded', open ? 'true' : 'false');
			if (label) {
				label.textContent = open
					? (btn.dataset.labelLess || 'Weniger anzeigen')
					: (btn.dataset.labelMore || 'Weiterlesen');
			}
			if (open) {
				var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
				window.setTimeout(function () {
					details.scrollIntoView({
						behavior: reduce ? 'auto' : 'smooth',
						block: 'start'
					});
				}, reduce ? 0 : 120);
			}
		});
	}

	function init() {
		document.querySelectorAll('[data-rubin-desc-toggle]').forEach(bind);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
	/* Re-bind inside the Shopify Theme Editor when the section re-renders */
	document.addEventListener('shopify:section:load', init);
})();
